import { formatDate } from "@clipboard-health/date-time";

interface SendbirdDateSeparatorProps {
  date: Date;
  timeZone: string;
}

export function SendbirdDateSeparator({ date, timeZone }: SendbirdDateSeparatorProps) {
  const formattedDate = formatDate(date, { timeZone });

  return (
    <div className="sendbird-separator">
      <div className="sendbird-separator__left sendbird-color--onbackground-4--background-color"></div>
      <div className="sendbird-separator__text">
        <span className="sendbird-label sendbird-label--caption-2 sendbird-label--color-onbackground-2">
          {formattedDate}
        </span>
      </div>
      <div className="sendbird-separator__right sendbird-color--onbackground-4--background-color"></div>
    </div>
  );
}
